import { useContext } from "react";
import Spinner from '@components/Spinner';
import Page404 from '@pages/NotFoundPage';
import HomeAccomodation from "@components/HomeAccomodation";
import { AccomodationContext } from "@utils/GlobalContext.js";

const AccomodationPage = () => {

  const { accomodationAndChildren, isPageNotFound } = useContext(AccomodationContext)
  if (accomodationAndChildren === undefined){
      return null
  }
    
  return (
    <div>
      <Spinner />
      {isPageNotFound ? (<Page404 />) : (<HomeAccomodation accomodationAndChildren={accomodationAndChildren} />)}
    </div>
  );
};
export default AccomodationPage;